
export default {
  name: 'UserHeader',
  props: {
    tit: {
      type: String,
      default: '头部'
    }
  },
  data() {
    return {}
  },
  mounted() {}
}
